export default "__VITE_ASSET__CIa5Qegx__"